//@flow
import { PROTOCOL, DOMAIN, USABLE_PORT } from "./config"

type ROUTE = { url: string, method: string }
type ROUTE_MAP = Map<string, ROUTE>

export const SIGNUP_ROUTE = "API_SIGNUP_ROUTE"
export const LOGIN_ROUTE = "API_LOGIN_ROUTE"
export const KIOSK_LOGIN_ROUTE = "API_KIOSK_LOGIN_ROUTE"
export const REFRESH_ROUTE = "API_REFRESH_ROUTE"
export const VALIDATE_EMAIL_ROUTE = "API_VALIDATE_EMAIL_ROUTE"
export const FORGOT_EMAIL_ROUTE = "API_FORGOT_EMAIL_ROUTE"
export const GRAPH_ROUTE = "API_GRAPHQL_ROUTE"
export const ROUTES: ROUTE_MAP = new Map()

const makeURL = (path: string): string =>
  `${PROTOCOL}://${DOMAIN}${USABLE_PORT}${path}`

ROUTES.set(SIGNUP_ROUTE, { url: makeURL("/auth/users"), method: "post" })
ROUTES.set(LOGIN_ROUTE, { url: makeURL("/auth/token"), method: "post" })
ROUTES.set(KIOSK_LOGIN_ROUTE, {
  url: makeURL("/auth/token/kiosk"),
  method: "post"
})
ROUTES.set(REFRESH_ROUTE, { url: makeURL("/auth/token"), method: "post" })
ROUTES.set(GRAPH_ROUTE, { url: makeURL("/graphql"), method: "post" })
ROUTES.set(VALIDATE_EMAIL_ROUTE, {
  url: makeURL("/auth/users/email"),
  method: "post"
})
ROUTES.set(FORGOT_EMAIL_ROUTE, {
  url: makeURL("/auth/users/forgot"),
  method: "post"
})



// WEBPACK FOOTER //
// ./src/API/routes.js